import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import { Gauge, IdentificationCard, Users, CalendarBlank, Storefront, Tag, SlidersHorizontal, FileText, Bank, Lifebuoy, ChatCircleText, GraduationCap, EnvelopeSimple } from "@phosphor-icons/react";

const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: Gauge, end: true },
  { to: "/admin/organizers", label: "Organizers", icon: IdentificationCard },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/events", label: "Events", icon: CalendarBlank },
  { to: "/admin/services", label: "Services & Pricing", icon: Storefront },
  { to: "/admin/catalog", label: "Genres & Coupons", icon: Tag },
  { to: "/admin/config", label: "Business Rules", icon: SlidersHorizontal },
  { to: "/admin/content", label: "CMS & Legal", icon: FileText },
  { to: "/admin/finance", label: "Finance", icon: Bank },
  { to: "/admin/emails", label: "Email Log", icon: EnvelopeSimple },
  { to: "/admin/chat", label: "Live Chat", icon: ChatCircleText },
  { to: "/admin/tutorial", label: "Tutorial", icon: GraduationCap },
  { to: "/admin/support", label: "Support", icon: Lifebuoy },
];

export default function AdminLayout() {
  return <DashboardLayout nav={ADMIN_NAV} kicker="Admin Console" />;
}
